import { Route, Switch } from "react-router-dom";
import { useRole, useContract } from "../ContractContext";
import NotFoundPage from "../../shared/error/NotFoundPage";
import { Role } from "../model/ContractViewModel";
import { ContractPath, CONTRACT_PATH_ROUTES } from "./ContractPath";
import { Suspense } from "react";
import LoadingPage from "../../shared/LoadingPage";
import FlowHeader from "../../layout/header/FlowHeader";

export default function ContractRoutes() {
  const role = useRole();
  const contract = useContract();
  const isInitiator = role === contract.initiator;

  return (
    <>
      <FlowHeader />
      <Suspense fallback={<LoadingPage />}>
        <Switch>
          {!isInitiator ? (
            <Route
              path={CONTRACT_PATH_ROUTES[ContractPath.invitation].path}
              component={
                CONTRACT_PATH_ROUTES[ContractPath.invitation].component
              }
            />
          ) : null}
          <Route
            path={CONTRACT_PATH_ROUTES[ContractPath.contract].path}
            component={CONTRACT_PATH_ROUTES[ContractPath.contract].component}
          />
          {role === Role.Buyer ? (
            <Route
              path={CONTRACT_PATH_ROUTES[ContractPath.financial].path}
              component={CONTRACT_PATH_ROUTES[ContractPath.financial].component}
            />
          ) : null}
          {role === Role.Seller ? (
            <Route
              path={CONTRACT_PATH_ROUTES[ContractPath.attachments].path}
              component={
                CONTRACT_PATH_ROUTES[ContractPath.attachments].component
              }
            />
          ) : null}
          <Route
            path={CONTRACT_PATH_ROUTES[ContractPath.trialMembership].path}
            component={
              CONTRACT_PATH_ROUTES[ContractPath.trialMembership].component
            }
          />
          {role === Role.Buyer ? (
            <Route
              path={CONTRACT_PATH_ROUTES[ContractPath.insurance].path}
              component={CONTRACT_PATH_ROUTES[ContractPath.insurance].component}
            />
          ) : null}
          {isInitiator ? (
            <Route
              path={CONTRACT_PATH_ROUTES[ContractPath.invite].path}
              component={CONTRACT_PATH_ROUTES[ContractPath.invite].component}
            />
          ) : null}
          <Route
            path={
              CONTRACT_PATH_ROUTES[
                ContractPath.signingMethodUpgradeContractPayment
              ].path
            }
            component={
              CONTRACT_PATH_ROUTES[
                ContractPath.signingMethodUpgradeContractPayment
              ].component
            }
          />
          <Route
            path={
              CONTRACT_PATH_ROUTES[ContractPath.signingMethodUpgradeContract]
                .path
            }
            component={
              CONTRACT_PATH_ROUTES[ContractPath.signingMethodUpgradeContract]
                .component
            }
          />
          <Route
            path={CONTRACT_PATH_ROUTES[ContractPath.signCallback].path}
            component={
              CONTRACT_PATH_ROUTES[ContractPath.signCallback].component
            }
          />
          <Route
            path={CONTRACT_PATH_ROUTES[ContractPath.sign].path}
            component={CONTRACT_PATH_ROUTES[ContractPath.sign].component}
          />
          <Route
            path={CONTRACT_PATH_ROUTES[ContractPath.status].path}
            component={CONTRACT_PATH_ROUTES[ContractPath.status].component}
          />
          <Route
            path={CONTRACT_PATH_ROUTES[ContractPath.financialConfirmation].path}
            component={
              CONTRACT_PATH_ROUTES[ContractPath.financialConfirmation].component
            }
          />
          <Route
            path={
              CONTRACT_PATH_ROUTES[ContractPath.postConfirmationTrialMembership]
                .path
            }
            component={
              CONTRACT_PATH_ROUTES[ContractPath.postConfirmationTrialMembership]
                .component
            }
          />
          <Route
            path={
              CONTRACT_PATH_ROUTES[ContractPath.postConfirmationInsurance].path
            }
            component={
              CONTRACT_PATH_ROUTES[ContractPath.postConfirmationInsurance]
                .component
            }
          />
          <Route
            path={CONTRACT_PATH_ROUTES[ContractPath.confirmation].path}
            component={
              CONTRACT_PATH_ROUTES[ContractPath.confirmation].component
            }
          />
          <Route
            path={
              CONTRACT_PATH_ROUTES[ContractPath.ownershipTransferPayment].path
            }
            component={
              CONTRACT_PATH_ROUTES[ContractPath.ownershipTransferPayment]
                .component
            }
          />
          <Route
            path={CONTRACT_PATH_ROUTES[ContractPath.ownershipTransfer].path}
            component={
              CONTRACT_PATH_ROUTES[ContractPath.ownershipTransfer].component
            }
          />
          <Route
            path={CONTRACT_PATH_ROUTES[ContractPath.preview].path}
            component={CONTRACT_PATH_ROUTES[ContractPath.preview].component}
          />
          {isInitiator ? (
            <Switch>
              <Route
                path={CONTRACT_PATH_ROUTES[ContractPath.typePayment].path}
                component={
                  CONTRACT_PATH_ROUTES[ContractPath.typePayment].component
                }
              />
              <Route
                path={CONTRACT_PATH_ROUTES[ContractPath.type].path}
                component={CONTRACT_PATH_ROUTES[ContractPath.type].component}
              />
            </Switch>
          ) : null}
          <Route component={NotFoundPage} />
        </Switch>
      </Suspense>
    </>
  );
}
